import React from "react";
import { BadgeGroup } from "./badge-group";
export function DestinationBadgeGroup(props) {
    return (React.createElement(BadgeGroup, { ...props, moreButtonProps: {
            fontSize: "sm",
            height: 6,
            px: 2,
            borderRadius: "md",
            borderWidth: "1px",
            borderColor: "gray.300",
            color: "ocean.600",
            transition: "100ms background",
            bg: "white",
            _hover: {
                bg: "gray.50",
            },
        } }));
}
